export default __webpack_public_path__ + "static/PAPC-401-de079c6c6f9c924d1a01c899ecc6e9aa.jpg";